// @flow
import type { Dispatch } from 'redux';
import { finectAPI } from '@finect/front-utils/finectAPI';
import type { TagType } from '../../types';
import { normalizeNO } from '../../utils';
import { setError } from '../error/actions';

export function setTags(tags: { [key: number]: TagType }) {
  return {
    type: 'SET_TAGS',
    tags
  };
}

export function setTag(tag: TagType) {
  return {
    type: 'SET_TAG',
    tag
  };
}

export function optimisticFollow(id: number, follow: boolean) {
  return {
    type: 'OPTIMISTIC_TAG_FOLLOW',
    id,
    follow
  };
}

// En api-v4 devolvemos menos datos
export function getTags(cookie?: string) {
  return (dispatch: Dispatch) =>
    finectAPI({
      version: 'v3',
      path: 'tags',
      method: 'GET',
      credentials: cookie,
      onSuccess: (tags) => {
        if (tags) {
          const normTags = normalizeNO(tags.data);
          dispatch(setTags(normTags));
        }
      },
      onError: error => dispatch(setError(error))
    });
}

// TODO: Restore using fetchAPI when possible
export function followTag(id: number) {
  return (dispatch: Dispatch) => {
    dispatch(optimisticFollow(id, true));
    const body = {
      id: id.toString(),
      type: 'tag'
    };
    fetch(`https://${process.env.FINECT_API_BASEURL || '/'}/v4/users/me/subscriptions`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(body)
    }).catch((err) => {
      dispatch(setError(err.code ? err : { code: 600, message: err }));
    });
  };
}

// TODO: Restore using fetchAPI when possible
export function unfollowTag(id: number) {
  return (dispatch: Dispatch) => {
    dispatch(optimisticFollow(id, false));
    fetch(`https://${process.env.FINECT_API_BASEURL || '/'}/v4/users/me/subscriptions?type=tag&id=${id}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include'
    }).catch((err) => {
      dispatch(setError(err.code ? err : { code: 600, message: err }));
    });
  };
}
